// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__2F2sv","image":"Card_image__3aAy1","type":"Card_type__34SmJ","title":"Card_title__1J8Wo","description":"Card_description__hI2H9","info":"Card_info__3NlCR"};